import { $member } from '@stores/memberStores';
import { BucketType } from '@types';
import getFileMd5 from '@utils/getFileMd5';
import TinyOSS from 'pano-tiny-oss';
import { getExt } from 'pano-utils';
import aliAuth from './aliAuth';

export async function uploadWatermark({ file }: { file: File }) {
  const uid = $member.getState().property?.uid;
  if (!uid) throw new Error('no uid');
  const resp = await aliAuth(BucketType.media);
  const md5 = await getFileMd5(file);
  const ext = getExt(file.name);
  const client = new TinyOSS({
    accessKeyId: resp.accessKeyId,
    accessKeySecret: resp.accessKeySecret,
    stsToken: resp.securityToken,
    bucket: resp.bucketName,
    endpoint: resp.endpointO,
    secure: true,
  });
  const url = `watermark/${uid}/${md5}.${ext}`;
  await client.put(url, file, {
    headers: {
      'x-oss-object-acl': 'public-read',
    },
  });

  return url;
}
